const DEFAULT_MANAGER_PORT = 32500;

export function jobViewUrl(ip: string, managerPort?: number): string {
  return `http://${ip}:${managerPort || DEFAULT_MANAGER_PORT}`;
}
